<template>
  <header
    v-if="user"
    @click="hideMenuOnExactLinkClick"
  >
    <div class="header align-items-center">
      <div class="container">
        <div class="row">
          <div class="col d-flex flex-grow-0 align-items-center justify-content-start">
            <div
              class="header__logo"
              data-navigation
            >
              <router-link
                class="header__logo__link"
                to="user-list"
              >
                <img
                  class="header__logo__image"
                  src="@/assets/BlobServer.png"
                  alt="Sollers SVO"
                >
              </router-link>
            </div>
            <div
              class="current-system"
              data-navigation
              menu-id="system"
              @click="toggleMainMenu"
            >
              <div class="current-system__block um">
                УП
              </div>
            </div>
          </div>
          <div class="col">
            <div
              class="header__menu"
              data-navigation
            >
              <router-link
                to="/user-list"
                class="header__menu__one"
                tag="span"
              >
                Список пользователей
              </router-link>
              <router-link
                v-if="user.interfaces.includes('UM-dealer-list')"
                to="/dealer-list"
                class="header__menu__one"
                tag="span"
              >
                Список дилеров
              </router-link>
              <router-link
                v-if="user.interfaces.includes('UM-role-edit') || user.interfaces.includes('UM-SVO-readonly')"
                to="/role-list"
                class="header__menu__one"
                tag="span"
              >
                Роли
              </router-link>
              <router-link
                v-if="user.interfaces.includes('UM-logs') || user.interfaces.includes('UM-SVO-reports') || user.interfaces.includes('UM-SVO-readonly') "
                to="/log-list"
                class="header__menu__one"
                tag="span"
              >
                Логи
              </router-link>
              <router-link
                v-if="user.interfaces.includes('UM-mail')"
                to="/email-list"
                class="header__menu__one"
                tag="span"
              >
                Архив писем
              </router-link>
              <router-link
                v-if="user.interfaces.includes('UM-mail-templates') || user.interfaces.includes('UM-SVO-readonly')"
                to="/template-list"
                class="header__menu__one"
                tag="span"
              >
                Шаблоны
              </router-link>
              <router-link
                v-if="user.interfaces.includes('UM-AAR')"
                to="/aar-list"
                class="header__menu__one"
                tag="span"
              >
                AAR
              </router-link>
            </div>
          </div>
          <div class="col-2">
            <div
              class="header__wrapper__profile"
              data-navigation
            >
              <div
                menu-id="profile"
                class="header__profile"
                @click="toggleMainMenu"
              >
                <span class="header__profile__name">
                  {{ user.name || user.email }}
                </span>
                <div class="header__profile__image-block">
                  <i
                    style="font-size: 40px;"
                    class="material-icons md-light"
                  >account_circle</i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition
      name="fade"
      mode="in-out"
    >
      <div
        v-show="isMenuShown"
        id="deepMenu"
        class="deep-menu"
      >
        <div class="container">
          <div
            class="row"
            data-navigation
          >
            <div class="col position-static">
              <div
                v-show="shownSubMenuId === 'profile'"
                menu-id="profile"
                class="deep-menu__block menu"
              >
                <router-link to="profile">
                  <i class="material-icons">account_circle</i>
                  Профиль
                </router-link>
                <a
                  class="text-danger"
                  href="javascript:void(0);"
                  @click="logOut"
                >
                  <i class="material-icons">subdirectory_arrow_left</i>
                  Выход
                </a>
              </div>
            </div>
            <div
              v-show="shownSubMenuId === 'profile'"
              class="container"
              menu-id="profile"
            >
              <div class="deep-menu__block link">
                <a
                  v-if="user.interfaces.includes('SVO')"
                  :href="`/${$config.PAGE_SVO_ORDERS}`"
                  class="deep-menu__block__link svo"
                >
                  <p class="deep-menu__block__link__title">Управление заказами</p>
                  <p class="deep-menu__block__link__text">Система для формирования заказов с опциями</p>
                </a>
                <a
                  v-if="user.interfaces.includes('UM')"
                  href="javascript:void(0)"
                  class="deep-menu__block__link um active"
                >
                  <p class="deep-menu__block__link__title">Управление пользователями</p>
                  <p class="deep-menu__block__link__text">Система для работы с пользователями</p>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </header>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'AppHeader',
  data: () => ({
    shownSubMenuId: null,
  }),
  computed: {
    ...mapState(['isMenuShown', 'user']),
  },
  mounted() {
    document.addEventListener('click', this.outOfHeaderClickHandler);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.outOfHeaderClickHandler);
  },
  methods: {
    outOfHeaderClickHandler(evt) {
      const navigation = Array.from(document.querySelectorAll('[data-navigation]'));
      let isNavigationClicked = false;

      navigation.forEach(it => {
        if (it.contains(evt.target)) {
          isNavigationClicked = true;
        }
      });

      if (!isNavigationClicked && this.isMenuShown) {
        this.$store.commit('hideMenu');
        this.selectedSubCatalog = null;
      }
    },
    toggleMainMenu(evt) {
      const prevSubMenuShown = this.shownSubMenuId;
      let target = evt.currentTarget;

      this.shownSubMenuId = target.getAttribute('menu-id');

      if (this.shownSubMenuId === 'system') {
        this.shownSubMenuId = 'profile';
        target = document.querySelector('[menu-id="profile"]');
      }

      this.$store.commit('toggleMenu');

      if (!this.isMenuShown && prevSubMenuShown !== this.shownSubMenuId) {
        this.$store.commit('showMenu');
      }

      // Задаем позицию для подменю
      const LeftCoord = target.getBoundingClientRect().left;
      const MenuId = target.getAttribute('menu-id');

      if (!target.classList.contains('active')) {
        Array.from(document.querySelectorAll('.deep-menu__block')).forEach(it => {
          if (it.getAttribute('menu-id') === MenuId) {
            it.style.left = `${LeftCoord}px`;
          }
        });
      }
    },
    hideMenuOnExactLinkClick(evt) {
      if (evt.target.classList.contains('router-link-exact-active')) {
        this.$store.commit('hideMenu');
      }
    },
    logOut() {
      this.$store.commit('logOut');
      this.$router.push('/sign-in');
    },
  },
};
</script>
